import { createReducer } from "reduxsauce"
import { without, forEach, get, includes } from "lodash"
import actionCreator from "helpers/actionCreator"
import { Types as CompositeTypes } from "modules/analyze-composite-security/model"
import { createDefaultReducer } from "helpers/reducers"

export const { Types, Creators } = actionCreator("ompnt/modules/analyzeCompositeComposition", {
  focusChartLine: {
    props: ["focusedChartLine"],
    track: false,
  },
  blurChartLine: { track: false },
  selectFactorCategory: {
    props: ["factorId"],
    trackType: "composite-analyze-composition-category-selection",
  },
  toggle: {
    props: ["factorId", "currentState"],
    trackType: "analyze-composition-graph-legend-factor",
    trackPayload: ({ factorId, currentState }) => ({ factor: factorId, state: currentState ? "on" : "off" }),
  },
  toggleOnly: {
    props: ["factorId", "only", "items"],
    trackType: "analyze-composition-graph-legend-factor",
    trackPayload: ({ factorId }) => ({ factor: factorId }),
  },
}, { track: true })

const DEFAULT_STATE = {
  focusedChartLine: null,
}

export default createReducer(DEFAULT_STATE, {
  [Types.FOCUS_CHART_LINE]: createDefaultReducer(),
  [Types.BLUR_CHART_LINE]: createDefaultReducer(),
})

const resetGraphState = (state) => ({
  ...state,
  disabled: null,
  only: null,
  focusedChartLine: null,
})

const handleSelectFactorCategory = (state, { factorId }) => ({
  ...resetGraphState(state),
  factorCategory: factorId,
})

const handleToggleQS = (state, { factorId }) => {
  const disabled = get(state, "disabled", [])
  const currentState = !includes(disabled, factorId)
  return {
    ...state,
    only: null,
    disabled: !currentState ? without(state.disabled, factorId) : [...(state.disabled || []), factorId],
  }
}

const handleToggleOnlyQS = (state, { factorId, only, items }) => {
  const disabled = []
  let onlyDisplay = null

  if (only) {
    onlyDisplay = factorId
    forEach(items, item => {
      if (item.id !== factorId) {
        disabled.push(item.id)
      }
    })
  }

  return { ...state, disabled, only: onlyDisplay }
}

export const queryStringReducers = {
  [Types.SELECT_FACTOR_CATEGORY]: handleSelectFactorCategory,
  [Types.TOGGLE]: handleToggleQS,
  [Types.TOGGLE_ONLY]: handleToggleOnlyQS,
  [CompositeTypes.SET_MODEL]: resetGraphState,
}
